/*# sourceMappingURL=weight.component-5AC5DVCH.css.map */
